import { render } from "./ConsultDetail_AiConsulting.vue?vue&type=template&id=d842bba4&scoped=true"
import script from "./ConsultDetail_AiConsulting.vue?vue&type=script&lang=js"
export * from "./ConsultDetail_AiConsulting.vue?vue&type=script&lang=js"

import "./ConsultDetail_AiConsulting.vue?vue&type=style&index=0&id=d842bba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d842bba4"]])

export default __exports__